// extracted by mini-css-extract-plugin
export default {"submit":"video_submit__YDmgj","video":"video_video__9VwEi","record":"video_record__XofHE"};